export { default } from './positionElement';



// WEBPACK FOOTER //
// ./src/index.js